import { render, staticRenderFns } from "./PanelPrincipal.vue?vue&type=template&id=b2675a48&scoped=true&"
import script from "./PanelPrincipal.vue?vue&type=script&lang=js&"
export * from "./PanelPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./PanelPrincipal.vue?vue&type=style&index=0&id=b2675a48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2675a48",
  null
  
)

export default component.exports